var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBullet = function SvgBullet(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 6,
    height: 6,
    fill: "none",
    viewBox: "0 0 6 6"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#632E38",
    fillRule: "evenodd",
    d: "M0 0h6v6H0z",
    clipRule: "evenodd"
  })));
};
export { SvgBullet as ReactComponent };